import axios from '@/libs/api.request'

export const login = ({ username, password }) => {
  const data = {
    username,
    password
  }
  return axios.request({
    url: 'login/ldap',
    data,
    method: 'post'
  })
}

export const getUserInfo = () => {
    return axios.request({
      url: 'currentuser',
      method: 'get'
    })
}

export const getRoutes = () => {
  return axios.request({
    url: '/api/v1/menu/menurole',
    method: 'get'
  })
}

export const getMenu = (token) => {
  return axios.request({
    url: 'home/menu',
    method: 'get'
  })
}

export const getMyk8s = () => {
  return axios.request({
    url: '/api/v1/permission/myk8s',
    method: 'get'
  })
 }

export const logout = (token) => {
  return axios.request({
    url: 'logout',
    method: 'post'
  })
}

export const modifyPassword = ({name, n, o}) => {
  const data = {
    name: name,
    new: n,
    old: o
  }
  return axios.request({
    url: '/api/v1/users/password/modify',
    data,
    method: 'put'
  })
}

export const checkPassword = ({name, password}) => {
  const data = {
    username: name,
    password: password
  }
  return axios.request({
    url: '/api/v1/users/password/check',
    data,
    method: 'post'
  })
}

export const bindMfa = (code) => {
  const data = {
    code
  }
  return axios.request({
    url: '/api/v1/users/mfa/bind',
    data,
    method: 'post'
  })
}

export const removeMfa = (code) => {
  const data = {
    code
  }
  return axios.request({
    url: '/api/v1/users/mfa/remove',
    data,
    method: 'post'
  })
}

export const getCasTicket = () => {
  return axios.request({
    url: '/cas/getTicket',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js